import ArrowRightIcon from 'assets/ver2/icons/arrow-nav-right.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  COUNTRY_FLAG_REFERENCES,
  ORDER_EMAIL,
  TRANSACTION_ADD_PREFIX,
} from 'constants';
import { format } from 'helpers';
import Cookies from 'helpers/cookies';
import { MAKE_PAYMENT_KEY } from 'hooks/form-add-transaction/useAddTransaction';
import { FX_MAKE_PAYMENT_KEY } from 'hooks/fx/useFxAddTransaction';
import useLang from 'hooks/useLang';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';

const ActiveItem = ({
  country,
  countryName,
  rates,
  remittanceRatesDataLength,
  position,
  handleOnNext,
  handleOnPrev,
}) => {
  const { t } = useLang();
  const navigate = useNavigate();

  const handleOnClick = () => {
    Cookies.remove(MAKE_PAYMENT_KEY);
    Cookies.remove(FX_MAKE_PAYMENT_KEY);
    Cookies.remove(ORDER_EMAIL);
    navigate(TRANSACTION_ADD_PREFIX);
  };

  const renderCurrencies = () => {
    if (Object.keys(rates).length === 0)
      return (
        <Currencies>
          <div>{t('label_no_rates_available')}</div>
        </Currencies>
      );
    const currenciesLength = Object.keys(rates).length;
    return (
      <Currencies $length={currenciesLength}>
        {Object.keys(rates).map((currencyCode, index) => {
          const rateInfo = rates[currencyCode];
          if (
            rateInfo.rate &&
            typeof rateInfo.rate === 'number' &&
            !isNaN(rateInfo.rate)
          ) {
            const formattedRate = format.toAmountStr2(rateInfo.rate);
            const isHighLight = index === 0;
            return (
              <div
                key={currencyCode}
                className={isHighLight && 'currency-code-highlight'}
                style={
                  !isHighLight && currenciesLength > 2 ? { float: 'left' } : {}
                }
              >
                <span>{rateInfo.currencyCode}</span>
                <br />
                <SizeBox height={4} />
                <span className="rate">{formattedRate}</span>
              </div>
            );
          }
          return null;
        })}
      </Currencies>
    );
  };

  if (!country) return null;
  return (
    <ItemWrap>
      <CountryName>
        <FlagIcon src={COUNTRY_FLAG_REFERENCES[country]} />
        {countryName}
      </CountryName>
      <Desc>{t('label_receiving_currency')}</Desc>
      <Desc style={{ fontSize: '12px' }}>
        ({t('label_exchange_rate_per_aud')})
      </Desc>
      {renderCurrencies()}
      <ButtonCommon
        value={t('button_send_now_2')}
        styles={{
          height: '44px',
          width: '200px',
          position: 'absolute',
          bottom: '12px',
          left: 'calc(50% - 100px)',
        }}
        onClick={handleOnClick}
      />
      <SlideArrow>
        <ArrowLeft
          style={{ transform: 'rotate(180deg)' }}
          src={ArrowRightIcon}
          width={20}
          height={20}
          onClick={handleOnPrev}
          $isHide={position === 0}
        />
        <ArrowRight
          src={ArrowRightIcon}
          width={20}
          height={20}
          onClick={handleOnNext}
          $isHide={position === remittanceRatesDataLength - 1}
        />
      </SlideArrow>
    </ItemWrap>
  );
};

const ItemWrap = styled.div`
  position: relative;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 290px;

  background: #081933;
  color: var(--ds-c-white);
  box-shadow: 0px 4px 15px 0px #0000001a;
  border-radius: 20px;

  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  text-align: left;
`;

const CountryName = styled.h4`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  font-family: var(--ff-primary);
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: #fff;
  font-weight: 500;
  margin: 0;
`;
const FlagIcon = styled.img`
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
`;

const Currencies = styled.div`
  width: 100%;
  margin-top: ${(props) => (props.$length > 1 ? '12px' : '36px')};
  & div {
    width: ${(props) => (props.$length > 2 ? '50%' : '100%')};
    text-align: center;
    & span {
      border: none;
      background: transparent;
      color: var(--c-quaternary);
      height: fit-content;
      line-height: 100%;
      font-size: 14px;
      font-weight: 500;
      text-transform: uppercase;
      padding: 0;
      margin-bottom: 2px;
    }
    & span.rate {
      font-size: 24px;
      color: #fff;
    }
  }
  & div.currency-code-highlight {
    width: ${(props) =>
      props.$length > 2 ? 'calc(100% - 32px)' : 'fit-content'};
    border-bottom: ${(props) => props.$length > 1 && '1px solid #3f3f3f'};
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-inline: auto;
    & span {
      font-size: 20px;
    }
    & span.rate {
      font-size: 40px;
    }
  }
`;

const Desc = styled.p`
  ${paragraphMixin};
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #fff;
  text-align: center;
  width: 100%;
`;

const SlideArrow = styled.div`
  height: 20px;
  width: calc(100% + 28px);
  margin-inline: -24px;
  background: transparent;
  position: absolute;
  top: calc(50% - 10px);
  display: flex;
  justify-content: space-between;
`;
const ArrowLeft = styled.img`
  cursor: pointer;
  opacity: ${(props) => (props.$isHide ? 0.5 : 1)};
`;
const ArrowRight = styled.img`
  cursor: pointer;
  opacity: ${(props) => (props.$isHide ? 0.5 : 1)};
`;

export default ActiveItem;
